import React, { useState } from 'react';
import { BsFillClipboardFill } from 'react-icons/bs';
import { Box, Icon, IconButton, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const CopyToClipboardIconButton = ({ text, variant = 'textPrimary' }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000); // Reset copied status after 2 seconds
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };

  return (
    <Box>
      <IconButton
        aria-label="copy-to-clipboard-button"
        icon={<Icon as={BsFillClipboardFill} />}
        size="sm"
        variant={variant}
        onClick={handleCopyClick}
      />
      <Box visibility={isCopied ? 'visible' : 'hidden'}>
        <Text color="greyScale.500" textStyle="bodySm">Copied!</Text>
      </Box>
    </Box>
  );
};

CopyToClipboardIconButton.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string
};

export default CopyToClipboardIconButton;
